import { useEffect, useState } from 'react';

import { getMobileIntlMaskForCountry, DEFAULT_MASK } from 'services/phoneMaskService';

import { addScript } from 'helpers/DOM';

// map CC / CX to AU for react-phone-input-2
const ISO2_ALIAS_FOR_PHONEINPUT = { cc: 'au', cx: 'au' };

export const useCountryMobileMask = (iso2) => {
    const [ready, setReady] = useState(false);
    const [maskData, setMaskData] = useState({ defaultMask: DEFAULT_MASK, masks: {}, iso2Ready: null });

    useEffect(() => {
        if (!__isBrowser__) return;
        if (window.libphonenumber) {
            setReady(true);
            return;
        }
        const selector = 'script[src*="libphonenumber-mobile.js"]';
        const existingScript = document.querySelector(selector);

        const markReadyIfLoaded = (scriptEl) => {
            const alreadyLoaded = !!window.libphonenumber || scriptEl?.readyState === 'complete' || scriptEl?.dataset?.loaded === 'true';
            if (alreadyLoaded) {
                setReady(true);
                return true;
            }
            return false;
        };
        if (existingScript) {
            if (markReadyIfLoaded(existingScript)) return;
            const onLoad = () => {
                existingScript.dataset.loaded = 'true';
                setReady(true);
            };
            existingScript.addEventListener('load', onLoad);
            return () => {
                existingScript.removeEventListener('load', onLoad);
            };
        }
        const libphonenumberFile = '/libphonenumber-mobile.js?v=1.10.60';
        addScript(libphonenumberFile, () => {
            try {
                const el = document.querySelector(selector);
                if (el) el.dataset.loaded = 'true';
            } catch (_) {}
            setReady(true);
        });
    }, []);

    useEffect(() => {
        let cancelled = false;
        if (!ready || !iso2) return;
        (async () => {
            const effectiveIso2 = ISO2_ALIAS_FOR_PHONEINPUT[iso2] || iso2;
            const mask = await getMobileIntlMaskForCountry(effectiveIso2);
            if (cancelled) return;
            setMaskData({
                defaultMask: mask,
                masks: { [effectiveIso2]: mask },
                iso2Ready: iso2,
            });
        })();
        return () => {
            cancelled = true;
        };
    }, [iso2, ready]);

    const isMaskReadyForIso2 = ready && maskData.iso2Ready === iso2;
    const effectiveIso2 = ISO2_ALIAS_FOR_PHONEINPUT[iso2] || iso2;

    return {
        defaultMask: maskData.defaultMask,
        masks: maskData.masks,
        isReady: ready,
        isMaskReadyForIso2,
        effectiveIso2,
    };
};
